var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOffsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0625 1.45875C0.0625 0.963765 0.463765 0.5625 0.95875 0.5625H5.03125C5.29013 0.5625 5.5 0.772367 5.5 1.03125C5.5 1.29013 5.29013 1.5 5.03125 1.5H1V10.5H10V6.46875C10 6.20987 10.2099 6 10.4688 6C10.7276 6 10.9375 6.20987 10.9375 6.46875V10.5413C10.9375 11.0362 10.5362 11.4375 10.0413 11.4375H0.95875C0.463765 11.4375 0.0625 11.0362 0.0625 10.5413V1.45875Z",
    fill: "#090B45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.03125C7 0.772367 7.20987 0.5625 7.46875 0.5625H10.4688C10.7276 0.5625 10.9375 0.772367 10.9375 1.03125V4.03125C10.9375 4.29013 10.7276 4.5 10.4688 4.5C10.2099 4.5 10 4.29013 10 4.03125V2.16291L4.05021 8.11271C3.86715 8.29576 3.57035 8.29576 3.38729 8.11271C3.20424 7.92965 3.20424 7.63285 3.38729 7.44979L9.33709 1.5H7.46875C7.20987 1.5 7 1.29013 7 1.03125Z",
    fill: "#090B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffsite);
export default __webpack_public_path__ + "static/media/icon-offsite.3760596a99e8e28da00183626999299a.svg";
export { ForwardRef as ReactComponent };